// extracted by mini-css-extract-plugin
module.exports = {"root":"fix-tarifa-detalles-inscritos_root__2r4uO","SectionTitle":"fix-tarifa-detalles-inscritos_SectionTitle__3_N_x"};